
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { useState } from 'react';
import SEOHead from '../../components/feature/SEOHead';

interface Product {
  id: string;
  name: string;
  destination: string;
  description: string;
  fullDescription: string;
  price: string;
  burnTime: string;
  waxType: string;
  size: string;
  image: string;
  images: string[];
  essentialOils: string[];
  fragranceNotes: {
    top: string[];
    heart: string[];
    base: string[];
  };
  careInstructions: string[];
}

const products: Record<string, Product> = {
  'portofino-morning': {
    id: 'portofino-morning',
    name: 'Portofino Morning',
    destination: 'Italian Riviera',
    description: 'Sun-warmed citrus, clean linen, and soft neroli \u2014 a morning on the Italian coast.',
    fullDescription: 'White stone terraces, blue water, and citrus trees swaying in the breeze. This essential oil blend distills the effortless luxury of an Italian coastal morning into a single flame. Bright neroli opens with sun-warmed confidence, orange oil lifts the air with clean energy, and lavender settles everything into calm sophistication. Light it, close your eyes, and you\u2019re there.',
    price: 'CA$25',
    burnTime: '35-40 hours',
    waxType: 'Natural soy wax with pure essential oils',
    size: 'Concrete vessel (approx. 4\u201D diameter)',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/495402795d5c018ad669106fdfe38d37.png',
    images: [
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/495402795d5c018ad669106fdfe38d37.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/ce5920a13287d8e4b6a7eaf25dec876f.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/6f9b3a45bdc2f32d089d8a157b4b4b0b.png'
    ],
    essentialOils: ['Neroli (Citrus aurantium)', 'Sweet Orange', 'Lavender', 'Cedarwood'],
    fragranceNotes: {
      top: ['Neroli (AMARA)', 'Orange oil'],
      heart: ['Lavender', 'White tea'],
      base: ['Clean musk', 'Soft cedarwood', 'Sun-warmed linen']
    },
    careInstructions: [
      'Trim wick to 1/4\u201D before each lighting',
      'Burn for 2-3 hours at a time for even wax pool',
      'Keep away from drafts and flammable materials',
      'Never leave burning candle unattended',
      'Concrete vessel may have unique natural variations'
    ]
  },
  'fleur-de-nuit': {
    id: 'fleur-de-nuit',
    name: 'Fleur de Nuit',
    destination: 'Paris at Midnight',
    description: 'Fresh roses, warm jasmine, and soft silk \u2014 a candlelit suite in Paris after dark.',
    fullDescription: 'A midnight balcony in a luxury Parisian hotel \u2014 rose arrangements, soft music, city lights below. This essential oil blend captures the intoxicating beauty of nighttime florals, where ylang ylang\u2019s exotic warmth meets jasmine\u2019s refined elegance and the timeless romance of fresh rose petals. One breath and you\u2019re standing on that balcony.',
    price: 'CA$25',
    burnTime: '35-40 hours',
    waxType: 'Natural soy wax with pure essential oils',
    size: 'Concrete vessel (approx. 4\u201D diameter)',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/96d7e3a6acb477d9e20976d786ab4dd6.png',
    images: [
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/96d7e3a6acb477d9e20976d786ab4dd6.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/6185afd4d042297cdce427ab62ea567c.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/1910d83cb9e301f1af9317fbe4c1c04a.png'
    ],
    essentialOils: ['Ylang Ylang', 'Jasmine absolute', 'Rose otto', 'Bergamot'],
    fragranceNotes: {
      top: ['Ylang Ylang', 'Bergamot'],
      heart: ['Jasmine absolute', 'Rose petals'],
      base: ['Warm musk', 'Soft sandalwood', 'Vanilla orchid']
    },
    careInstructions: [
      'Trim wick to 1/4\u201D before each lighting',
      'Burn for 2-3 hours at a time for even wax pool',
      'Keep away from drafts and flammable materials',
      'Never leave burning candle unattended',
      'Concrete vessel may have unique natural variations'
    ]
  },
  'lavender-terrace': {
    id: 'lavender-terrace',
    name: 'Lavender Terrace',
    destination: 'Provence, France',
    description: 'Lavender air, warm cream, and golden hour \u2014 a sunset terrace in Provence.',
    fullDescription: 'A stone terrace overlooking endless lavender fields as the sun goes down. This essential oil blend captures the serenity of Provence at golden hour, where French lavender meets warm vanilla in a blend that feels like total peace. The concrete vessel holds the warmth long after the flame is out \u2014 just like the memory of that terrace.',
    price: 'CA$25',
    burnTime: '35-40 hours',
    waxType: 'Natural soy wax with pure essential oils',
    size: 'Concrete vessel (approx. 4\u201D diameter)',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/824cb0538fbd7ad03af28ba2d3d75796.png',
    images: [
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/824cb0538fbd7ad03af28ba2d3d75796.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/039b0ec29f1ba72e71849183d1dbf49c.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/99b1ab970f34cf753513f0d4ea4155eb.png'
    ],
    essentialOils: ['French Lavender', 'Lavandin', 'Bergamot', 'Vanilla CO2'],
    fragranceNotes: {
      top: ['French lavender', 'Bergamot'],
      heart: ['Lavender absolute', 'Vanilla orchid'],
      base: ['Warm vanilla', 'Soft musk', 'Cashmere wood']
    },
    careInstructions: [
      'Trim wick to 1/4\u201D before each lighting',
      'Burn for 2-3 hours at a time for even wax pool',
      'Keep away from drafts and flammable materials',
      'Never leave burning candle unattended',
      'Concrete vessel may have unique natural variations'
    ]
  },
  'velvet-study': {
    id: 'velvet-study',
    name: 'Velvet Study',
    destination: 'English Countryside',
    description: 'Polished wood, warm smoke, and leather \u2014 a private library after midnight.',
    fullDescription: 'Leather chairs, old books, a brass lamp \u2014 late-night focus and slow luxury. This essential oil blend captures the atmosphere of a private study in an English country estate after midnight, where sandalwood meets cedarwood and a subtle tobacco warmth fills the room. The raw concrete vessel grounds the experience \u2014 heavy, tactile, permanent.',
    price: 'CA$25',
    burnTime: '35-40 hours',
    waxType: 'Natural soy wax with pure essential oils',
    size: 'Concrete vessel (approx. 4\u201D diameter)',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/a505396c8e4926ad7e295ea97cee7366.png',
    images: [
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/a505396c8e4926ad7e295ea97cee7366.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/de9116827b36f057d9935e29381c83f0.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/159fe9f2121619936aa0fa56fc42eb9a.png'
    ],
    essentialOils: ['Sandalwood', 'Cedarwood (Atlas)', 'Black Pepper', 'Vetiver'],
    fragranceNotes: {
      top: ['Sandalwood', 'Black pepper'],
      heart: ['Cedarwood', 'Tobacco leaf'],
      base: ['Smoked amber', 'Leather', 'Warm musk']
    },
    careInstructions: [
      'Trim wick to 1/4\u201D before each lighting',
      'Burn for 2-3 hours at a time for even wax pool',
      'Keep away from drafts and flammable materials',
      'Never leave burning candle unattended',
      'Concrete vessel may have unique natural variations'
    ]
  },
  'nordic-spa': {
    id: 'nordic-spa',
    name: 'Nordic Spa',
    destination: 'Scandinavia',
    description: 'Eucalyptus steam, cool mint, and clean stone \u2014 a luxury spa in the Nordic fjords.',
    fullDescription: 'A Scandinavian spa suite: hot steam, cool air, clean stone, and quiet. This essential oil blend captures the invigorating clarity of a Nordic wellness ritual, where eucalyptus opens the senses, peppermint sharpens the mind, and rosemary grounds everything in herbal calm. The concrete vessel echoes the raw stone of the spa itself.',
    price: 'CA$25',
    burnTime: '35-40 hours',
    waxType: 'Natural soy wax with pure essential oils',
    size: 'Concrete vessel (approx. 4\u201D diameter)',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/f133e1f2fb337cf7f9c43493aab68580.png',
    images: [
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/f133e1f2fb337cf7f9c43493aab68580.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/7371cfdeb9ff579feb7b507f96126cb0.png',
      'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/6c1b70564fd852538af5cd7a481bfd7b.png'
    ],
    essentialOils: ['Eucalyptus (Globulus)', 'Peppermint', 'Rosemary', 'Pine needle'],
    fragranceNotes: {
      top: ['Eucalyptus', 'Peppermint'],
      heart: ['Rosemary', 'White tea'],
      base: ['Clean musk', 'Cool cedar', 'Mineral stone']
    },
    careInstructions: [
      'Trim wick to 1/4\u201D before each lighting',
      'Burn for 2-3 hours at a time for even wax pool',
      'Keep away from drafts and flammable materials',
      'Never leave burning candle unattended',
      'Concrete vessel may have unique natural variations'
    ]
  }
};

const relatedProducts = [
  {
    id: 'portofino-morning',
    name: 'Portofino Morning',
    destination: 'Italian Riviera',
    price: 'CA$25',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/495402795d5c018ad669106fdfe38d37.png'
  },
  {
    id: 'fleur-de-nuit',
    name: 'Fleur de Nuit',
    destination: 'Paris at Midnight',
    price: 'CA$25',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/96d7e3a6acb477d9e20976d786ab4dd6.png'
  },
  {
    id: 'velvet-study',
    name: 'Velvet Study',
    destination: 'English Countryside',
    price: 'CA$25',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/a505396c8e4926ad7e295ea97cee7366.png'
  },
  {
    id: 'lavender-terrace',
    name: 'Lavender Terrace',
    destination: 'Provence, France',
    price: 'CA$25',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/824cb0538fbd7ad03af28ba2d3d75796.png'
  },
  {
    id: 'nordic-spa',
    name: 'Nordic Spa',
    destination: 'Scandinavia',
    price: 'CA$25',
    image: 'https://static.readdy.ai/image/e303b6d8f85cec63989e257b3b543d6f/f133e1f2fb337cf7f9c43493aab68580.png'
  }
];

export default function ProductPage() {
  const { productId } = useParams<{ productId: string }>();
  const [selectedImage, setSelectedImage] = useState(0);

  const product = productId ? products[productId] : null;
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  if (!product) {
    return (
      <div className="min-h-screen bg-[#0B1B3A]">
        <Header />
        <div className="pt-32 pb-20 px-6 text-center">
          <h1 className="text-3xl font-serif text-[#F5F0E8] mb-4">Product Not Found</h1>
          <Link to="/">
            <Button variant="primary" size="md">Return Home</Button>
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const filteredRelated = relatedProducts.filter(p => p.id !== product.id).slice(0, 4);

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "image": product.images,
    "description": product.fullDescription,
    "brand": {
      "@type": "Brand",
      "name": "ignight"
    },
    "offers": {
      "@type": "Offer",
      "url": `${siteUrl}/product/${product.id}`,
      "priceCurrency": "CAD",
      "price": product.price.replace('$', ''),
      "availability": "https://schema.org/OutOfStock",
      "itemCondition": "https://schema.org/NewCondition"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    }
  };

  return (
    <>
      <SEOHead
        title={`${product.name} - ${product.destination} | ignight Luxury Concrete Candles`}
        description={`${product.description} Handcrafted with pure essential oils including ${product.essentialOils.slice(0, 3).join(', ')}. ${product.burnTime} burn time in a unique concrete vessel.`}
        keywords={`${product.name}, ${product.destination} candle, concrete candle, essential oil candle, ${product.essentialOils[0]}, luxury candle`}
        canonical={`${siteUrl}/product/${product.id}`}
        schema={productSchema}
      />
      <div className="min-h-screen bg-[#0B1B3A]">
        <Header />
        
        {/* Product Detail */}
        <section className="pt-20 sm:pt-32 pb-12 sm:pb-20 px-4 sm:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-16">
              {/* Images */}
              <div>
                <div className="aspect-square overflow-hidden rounded-lg bg-[#132847] mb-3 sm:mb-4 relative">
                  <div className="absolute top-3 right-3 z-10 bg-[#0B1B3A]/90 text-[#E8A0A0] text-xs font-medium px-3 py-1.5 rounded-full uppercase tracking-wider">
                    Sold Out
                  </div>
                  <img
                    src={product.images[selectedImage]}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                
                <div className="grid grid-cols-3 gap-2 sm:gap-4">
                  {product.images.map((image, index) => (
                    <button
                      key={index}
                      onClick={() => setSelectedImage(index)}
                      className={`aspect-square overflow-hidden rounded-lg bg-[#132847] cursor-pointer transition-all ${
                        selectedImage === index ? 'ring-2 ring-[#D4C5A9]' : 'hover:ring-2 hover:ring-[#2A4A73]'
                      }`}
                    >
                      <img
                        src={image}
                        alt={`${product.name} ${index + 1}`}
                        className="w-full h-full object-cover object-top"
                      />
                    </button>
                  ))}
                </div>
              </div>

              {/* Product Info */}
              <div>
                <div className="mb-4 sm:mb-6">
                  <div className="flex items-center gap-1.5 mb-1 sm:mb-2">
                    <i className="ri-map-pin-line text-[#6B83A8] text-xs"></i>
                    <p className="text-xs tracking-widest text-[#6B83A8] uppercase">{product.destination}</p>
                  </div>
                  <h1 className="text-2xl sm:text-4xl font-serif text-[#F5F0E8] mb-3 sm:mb-4">{product.name}</h1>
                  <p className="text-xl sm:text-2xl font-medium text-[#D4C5A9] mb-4 sm:mb-6 line-through opacity-50">{product.price}</p>
                  <p className="text-base sm:text-lg text-[#8A9BB5] leading-relaxed mb-3 sm:mb-4">{product.description}</p>
                  <p className="text-sm sm:text-base text-[#8A9BB5] leading-relaxed">{product.fullDescription}</p>
                </div>

                {/* Essential Oils */}
                <div className="mb-4 sm:mb-6 bg-[#0E2244] rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-3">
                    <i className="ri-flask-line text-[#D4C5A9] text-base"></i>
                    <h3 className="text-sm font-medium text-[#F5F0E8] uppercase tracking-wider">Essential Oils Used</h3>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {product.essentialOils.map((oil, index) => (
                      <span key={index} className="text-xs text-[#8A9BB5] bg-[#162D52] px-3 py-1.5 rounded-full">
                        {oil}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Sold Out Notice */}
                <div className="mb-4 sm:mb-6 bg-[#2A1A1A] border border-[#5A3030] rounded-lg p-4 sm:p-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-[#3A2020] flex items-center justify-center flex-shrink-0">
                      <i className="ri-close-circle-line text-[#E8A0A0] text-xl"></i>
                    </div>
                    <div>
                      <p className="text-base font-medium text-[#E8A0A0]">Currently Sold Out</p>
                      <p className="text-xs text-[#8A6B6B] mt-0.5">This item is not available for purchase at this time.</p>
                    </div>
                  </div>
                </div>

                <div className="w-full py-3 rounded-lg text-sm font-medium bg-[#162D52] text-[#6B83A8] text-center cursor-not-allowed whitespace-nowrap mb-4">
                  <i className="ri-shopping-cart-line mr-2 opacity-50"></i>
                  Sold Out
                </div>

                {/* Product Details */}
                <div className="border-t border-[#162D52] pt-4 sm:pt-6 mt-4 sm:mt-6">
                  <h3 className="text-base sm:text-lg font-serif text-[#F5F0E8] mb-3 sm:mb-4">Product Details</h3>
                  <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-[#8A9BB5]">
                    <div className="flex justify-between">
                      <span>Burn Time:</span>
                      <span className="font-medium text-[#F5F0E8]">{product.burnTime}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Wax Type:</span>
                      <span className="font-medium text-[#F5F0E8]">{product.waxType}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Vessel:</span>
                      <span className="font-medium text-[#F5F0E8]">{product.size}</span>
                    </div>
                  </div>
                </div>

                {/* Fragrance Notes */}
                <div className="border-t border-[#162D52] pt-4 sm:pt-6 mt-4 sm:mt-6">
                  <h3 className="text-base sm:text-lg font-serif text-[#F5F0E8] mb-3 sm:mb-4">Fragrance Journey</h3>
                  <div className="space-y-3 sm:space-y-4">
                    <div>
                      <p className="text-xs tracking-widest text-[#6B83A8] uppercase mb-1 sm:mb-2">First Impression</p>
                      <p className="text-xs sm:text-sm text-[#8A9BB5]">{product.fragranceNotes.top.join(', ')}</p>
                    </div>
                    <div>
                      <p className="text-xs tracking-widest text-[#6B83A8] uppercase mb-1 sm:mb-2">The Arrival</p>
                      <p className="text-xs sm:text-sm text-[#8A9BB5]">{product.fragranceNotes.heart.join(', ')}</p>
                    </div>
                    <div>
                      <p className="text-xs tracking-widest text-[#6B83A8] uppercase mb-1 sm:mb-2">The Memory</p>
                      <p className="text-xs sm:text-sm text-[#8A9BB5]">{product.fragranceNotes.base.join(', ')}</p>
                    </div>
                  </div>
                </div>

                {/* Care Instructions */}
                <div className="border-t border-[#162D52] pt-4 sm:pt-6 mt-4 sm:mt-6">
                  <h3 className="text-base sm:text-lg font-serif text-[#F5F0E8] mb-3 sm:mb-4">Care Instructions</h3>
                  <ul className="space-y-1 sm:space-y-2">
                    {product.careInstructions.map((instruction, index) => (
                      <li key={index} className="flex items-start gap-2 text-xs sm:text-sm text-[#8A9BB5]">
                        <span className="text-[#6B83A8] mt-1">&bull;</span>
                        <span>{instruction}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* You May Also Like */}
        <section className="py-12 sm:py-20 px-4 sm:px-6 bg-[#0E2244]">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl sm:text-3xl font-serif text-[#F5F0E8] mb-2 text-center">Explore More Destinations</h2>
            <p className="text-sm text-[#6B83A8] text-center mb-8 sm:mb-12">Where will you go next?</p>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
              {filteredRelated.map((relatedProduct) => (
                <Link key={relatedProduct.id} to={`/product/${relatedProduct.id}`} className="group">
                  <div className="bg-[#132847] rounded-lg overflow-hidden hover:shadow-lg hover:shadow-black/30 transition-shadow relative">
                    <div className="absolute top-2 right-2 z-10 bg-[#0B1B3A]/90 text-[#E8A0A0] text-xs font-medium px-2 py-0.5 rounded-full uppercase tracking-wider">
                      Sold Out
                    </div>
                    <div className="aspect-square overflow-hidden bg-[#1A3358]">
                      <img
                        src={relatedProduct.image}
                        alt={relatedProduct.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500 opacity-60"
                      />
                    </div>
                    <div className="p-3 sm:p-6">
                      <div className="flex items-center gap-1 mb-1">
                        <i className="ri-map-pin-line text-[#6B83A8] text-xs"></i>
                        <p className="text-xs text-[#6B83A8] tracking-wider">{relatedProduct.destination}</p>
                      </div>
                      <h3 className="text-sm sm:text-lg font-serif text-[#F5F0E8] mb-2">{relatedProduct.name}</h3>
                      <p className="text-sm sm:text-lg font-medium text-[#D4C5A9] line-through opacity-50">{relatedProduct.price}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
